import styled, { css } from 'styled-components';
import { TopButtonsContainerProps } from './types';
import { DANGER_COLOR, DEFAULT_BG_COLOR, WARNING_COLOR } from 'shared/consts';

export const ButtonsContainer = styled.div``;

export const ButtonContainer = styled.div`
	margin-bottom: 5px;
`;

const getColor = (variant?: string) => {
	switch (variant) {
		case 'danger':
			return DANGER_COLOR;
		case 'warning':
			return WARNING_COLOR;
		case 'default':
			return DEFAULT_BG_COLOR;
		default:
			return DEFAULT_BG_COLOR;
	}
};

export const TopButtonsContainer = styled.div<TopButtonsContainerProps>`
	display: flex;
	justify-content: space-between;
	background: ${(props: TopButtonsContainerProps) => getColor(props.$colorVariant)};
	height: 58px;
	align-items: center;
	padding-left: 10px;
	padding-right: 20px;

	${(props: TopButtonsContainerProps) =>
		props.$roundedBorders &&
		css`
			border-top-right-radius: 24px;
			border-top-left-radius: 24px;
		`};
`;

export const Padding = styled.div`
	padding: 16px 12px;
`;
